import Header from '../components/header';
import React from 'react';
import '../index.css';
import { Container, Row, Col} from 'react-bootstrap';
import {FaRoute} from 'react-icons/fa';
import { getEducationsData } from '../data/educationData';
import Footer from '../components/footer';

function Education() {
    const educations = getEducationsData();

    return (
        <>
            <Header />

            <Container className="journey-container fade-in-up gap-3 p-3">
                <Row className="justify-content-center p-3 mb-3">
                    <Col className="text-start d-flex align-items-center justify-content-start">
                        <FaRoute className='page-img'></FaRoute>
                        <h2 className="heading m-0">JOURNEY</h2>
                    </Col>
                </Row>
                {educations.map(education => (
                    <Row key={education.id} className="justify-content-center p-3 pt-0 mb-3">
                        <Col lg={12} className="text-start">
                            <h3 className="heading3">{education.degree}</h3>
                            <p className="m-0">{education.details}</p>
                        </Col>
                        <Col lg={12} className="my-card learnt p-3 mt-2">
                            <ul className='my-2'>
                                {education.subjects.map((subject, index) => (
                                    <li key={index}><span>{subject.title}:</span> {subject.description}</li>
                                ))}
                            </ul>
                        </Col>
                    </Row>
                ))}
            </Container>
                        <Footer />
            
        </>
    );
}

export { Education };
